import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import ActionBtn from "../../../components/dashboard/btn/ActionBtn";
import { BreadCrumb } from "primereact/breadcrumb";
import { routes } from "../../../routes";
import { useParams } from "react-router-dom";
import BranchService from "../../../api/BranchService";
import { FilterMatchMode } from "primereact/api";
import TrainingService from "../../../api/TrainingService";
import SearchComponent from "../../../components/datatable/SearchComponent";
import { Dropdown } from "primereact/dropdown";
import { ProgressSpinner } from "primereact/progressspinner";
import EmptyMessage from "../../../components/datatable/EmptyMessage";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";

const Site = () => {
  const [addVisible, setAddVisible] = useState(false);
  const [siteName, setSiteName] = useState("");
  const items = [{ label: `Site - ${siteName} - Parcours` }];
  const [refresh, setRefresh] = useState(false);
  const [trainings, setTrainings] = useState([]);
  const [training, setTraining] = useState("");
  const [branch, setBranch] = useState("");
  const toast = useRef(null);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    //name: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
  });
  const candidate = {
    icon: "pi pi-lock",
    url: routes.dashboard.defaultPath /* + routes.dashboard.sites.path */,
  };
  const [sites, setSites] = useState([]);
  const { id } = useParams();
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  useEffect(() => {
    setLoading(true);
    BranchService.get(id)
      .then((res) => {
        setSiteName(res.data.branch.name);
        setSites(res.data.branch.training_programs);
        setLoading(false);
      })
      .catch((err) => console.error(err));
    TrainingService.getAll()
      .then((res) => {
        setTrainings(res.data.trainingPrograms);
      })
      .catch((err) => {});
  }, [id, refresh]);
  const header = () => {
    return (
      <div className="flex justify-content-between">
        <Button
          color="#fff"
          icon="pi pi-plus"
          label="Ajouter un parcours"
          onClick={() => setAddVisible(true)}
        />
        <SearchComponent
          globalFilterValue={globalFilterValue}
          onGlobalFilterChange={onGlobalFilterChange}
        />
      </div>
    );
  };
  const [loading, setLoading] = useState(true);
  /* const actionTemplate = (rowData) => {
    return (
      <div className="flex flex-wrap justify-content-start gap-3">
        <ActionBtn
          icon="pi pi-plus"
          severity="primary"
          tooltip="Associer un parcours"
          //handleClick={}
        />
        
      </div>
    );
  }; */
  const fieldTemplate = (rowData) => {
    return (
      <div className="flex flex-wrap justify-content-start gap-3">
        <ul>
          {rowData &&
            rowData.fields.map((row, index) => (
              <li style={{ listStyleType: "initial" }} key={index}>
                {row.name}
              </li>
            ))}
        </ul>
      </div>
    );
  };
  const addTraining = (e) => {
    e.preventDefault();
    const data = {
      branch_id: id,
      training_program_id: training.id,
    };
    setLoading(true);
    BranchService.createBranchTraining(data)
      .then((res) => {
        if (res.data.error) {
          setLoading(false);
          setAddVisible(false);
          toast.current.show({
            severity: "error",
            summary: "Erreur",
            detail: "Erreur lors de l'ajout du parcours",
            life: 3000,
          });        } else {
          setLoading(false);
          setAddVisible(false);
          setRefresh(!refresh);
          toast.current.show({
            severity: "info",
            summary: "Succèss",
            detail: "Parcours ajouté avec succès",
            life: 3000,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        setAddVisible(false);
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur lors de l'ajout du parcours",
          life: 3000,
        });
      });
  };
  return (
    <div>
      <Toast ref={toast} />
      <Dialog
        header="Ajouter Parcours"
        visible={addVisible}
        style={{ width: "50vw" }}
        onHide={() => setAddVisible(false)}
      >
        <form className="form" onSubmit={addTraining}>
          <div className="form__item">
            <label htmlFor="site">Parcours</label>
            <div className="form__item__ic_p">
              <Dropdown
                value={training}
                onChange={(e) => {
                  setTraining(e.value);
                }}
                options={trainings}
                optionLabel="name"
                placeholder="Sectionner un parcours"
                className="w-full"
              />
            </div>
          </div>

          <div className="form__item">
            <button type="submit">
              Enregistrer{" "}
              <ProgressSpinner
                style={
                  loading
                    ? { width: "20px", height: "20px" }
                    : { width: "0px", height: "0px" }
                }
                strokeWidth="8"
                loading={loading}
              />
            </button>
          </div>
        </form>
      </Dialog>
      <BreadCrumb model={items} home={candidate} />
      <div>
        <DataTable
          value={sites}
          tableStyle={{ minWidth: "50rem" }}
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25, 50]}
          dataKey="id"
          filters={filters}
          loading={loading}
          //globalFilterFields={["name"]}
          header={header}
          emptyMessage={EmptyMessage}
        >
          <Column field="name" header="Nom" style={{ width: "40%" }}></Column>
          <Column
            field="duration"
            header="Durée"
            style={{ width: "20%" }}
          ></Column>
          <Column
            field="description"
            header="Description"
            style={{ width: "40%" }}
          ></Column>
          {/*  <Column
            header="Action"
            body={actionTemplate}
            style={{ width: "30%" }}
          ></Column> */}
        </DataTable>
      </div>
    </div>
  );
};

export default Site;
